import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const TopFeatures = (props: any) => {
  const { facilityData } = props;
  const [topFeatures, setTopFeatures] = useState([]);

  useEffect(() => {
    const sorted = facilityData?.attributes?.Features?.data?.sort(
      (a: any, b: any) => {
        const priorityA = a.attributes.priority ?? Infinity;
        const priorityB = b.attributes.priority ?? Infinity;
        return priorityA - priorityB;
      }
    );
    setTopFeatures(sorted);
  }, [facilityData]);

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        const closeButton = document.querySelector(
          '[data-bs-dismiss="modal"]'
        ) as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => document.removeEventListener('keydown', handleEscKey);
  }, []);

  const defaultIcon = '/images/features-tick-icon.svg';

  return (
    <section>
      <div className="sv-store-features">
        <div className="sv-store-top-features">
          <h2 className="sub-heading mb-0 text-black">
            <FormattedMessage id="topFeatures" />
          </h2>
          {topFeatures?.length > 6 && (
            <button
              className="btn btn-link sv-storeAddress p-0 text-decoration-none p-0"
              data-bs-toggle="modal"
              data-bs-target="#featuresModal"
            >
              <FormattedMessage id="seeAll" />{' '}
              <span>
                <img src="/images/right-blue-arrow.svg" alt="right arrow" />
              </span>
            </button>
          )}
        </div>
        <div className="row unitFeaturesContent">
          <div className="col-6">
            {topFeatures?.slice(0, 3).map((feature, index) => (
              <div className="featuresList" key={index}>
                <img
                  src={
                    feature?.attributes.Icon?.data?.attributes?.url ||
                    defaultIcon
                  }
                  alt="feature icon"
                  className="feature-icon me-3"
                />
                <span className="sv-feature-name ellipsis">
                  {feature?.attributes.Title}
                </span>
              </div>
            ))}
          </div>

          <div className="col-6">
            {topFeatures?.slice(3, 6).map((feature, index) => (
              <div className="d-flex align-items-center mb-3" key={index + 3}>
                <img
                  src={
                    feature?.attributes.Icon?.data?.attributes?.url ||
                    defaultIcon
                  }
                  alt="feature icon"
                  className="feature-icon me-3"
                />
                <span className="sv-feature-name ellipsis">
                  {feature?.attributes.Title}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="sv-store-top-features-responsive">
          {topFeatures.length > 6 && (
            <button
              className="btn btn-link sv-storeAddress p-0 w-100 text-decoration-none"
              data-bs-toggle="modal"
              data-bs-target="#featuresModal"
            >
              All Features{' '}
              <span>
                <img src="/images/sv-plus-icon.svg" alt="add" />
              </span>
            </button>
          )}
        </div>
      </div>
      <div
        className="modal fade"
        id="featuresModal"
        role="dialog"
        aria-labelledby="featuresModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close sv-close-btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src="/images/sv-modal-cross-icon.svg" alt="Cross icon" />
              </button>
            </div>
            <div className="modal-body p-0">
              {/* First section - Detailed Features */}
              <div className="sv-features-modal">
                <div className="d-flex justify-content-between align-items-center">
                  <h5
                    className="sv-dark-black-bold-para sub-heading"
                    id="featuresModalLabel"
                  >
                    Top Features
                  </h5>
                </div>

                {topFeatures?.slice(0, 3).map((feature, index) => (
                  <div className="featuresList" key={index}>
                    <img
                      src={
                        feature?.attributes.Icon?.data?.attributes?.url ||
                        defaultIcon
                      }
                      alt="feature icon"
                      className="feature-icon me-2"
                    />
                    <div>
                      <p className="sv-feature-title mb-0">
                        {feature?.attributes.Title}
                      </p>
                      <p className="sv-feature-description mb-0">
                        {feature?.attributes.Description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Second section - Grid Style Features */}
              <div className="sv-features-grid">
                <div className="row align-items-center">
                  {topFeatures?.slice(3).map((feature, index) => (
                    <div
                      className="col-lg-6 col-md-6 col-sm-6 col-6 featuresList"
                      key={index}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            feature?.attributes.Icon?.data?.attributes?.url ||
                            defaultIcon
                          }
                          alt="feature icon"
                          className="feature-icon me-2"
                        />
                        <span className="sv-feature-title">
                          {feature?.attributes.Title}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopFeatures;
